import React from 'react'
import PropTypes from 'prop-types'

import { Dropdown } from '@scentregroup/ui'
import productAddToCart from '../../../helpers/analytics-utils/product-add-to-cart'
import style from './index.scss'

const WESTFIELD_PREFIX = 'Westfield '
const WESTFIELD_LENGTH = WESTFIELD_PREFIX.length

function handleChange(product, history, event) {
  if (event.target.value !== undefined) {
    const centreDropdown = event.target
    const centreName = centreDropdown.options[centreDropdown.selectedIndex].text

    productAddToCart(product, {
      eventLabel: 'Select Centre',
      centre_name: centreName,
    })

    window.location = centreDropdown.value
  }
}

function removeWestfieldPrefix(centreName) {
  return centreName.startsWith(WESTFIELD_PREFIX)
    ? centreName.substring(WESTFIELD_LENGTH)
    : centreName
}

function compareStrings(a, b) {
  const aUpper = a.toUpperCase()
  const bUpper = b.toUpperCase()
  const LOWER_INDEX = -1
  const HIGHER_INDEX = 1
  const NO_CHANGE = 0
  if (aUpper < bUpper) {
    return LOWER_INDEX
  } else if (aUpper > bUpper) {
    return HIGHER_INDEX
  } else {
    return NO_CHANGE
  }
}

function storeOptions(product) {
  const centreMap = {}
  product.centres.forEach(
    centre => (centreMap[centre.centreId] = removeWestfieldPrefix(centre.name))
  )
  const defaultOption = { label: 'Select centre', value: undefined }
  // Algolia sometimes returns duplicate stores, we need to de-dupe the values

  const storeMap = product.stores.reduce((sm, store) => {
    sm[store.centreId] = store
    return sm
  }, {})

  // eslint-disable-next-line compat/compat
  const options = Object.values(storeMap)
    .map(store => ({
      label: centreMap[store.centreId] || store.centreId,
      value: `/${store.centreId}/products/${product.retailer.retailerCode}/${product.nameSlug}/${product.objectId}`,
    }))
    .sort((a, b) => compareStrings(a.label, b.label))
  return [defaultOption, ...options]
}

export const StockAvailability = ({ product, history }) => (
  <div className={style.stockAvailability}>
    <div className={style['title']}>Stock availability</div>
    <p>
      Please check the latest pricing and stock availability directly with the
      retailer before travelling to the centre.
    </p>
    <Dropdown
      classNames={{ wrapper: style.storeSelector, field: style.field }}
      options={storeOptions(product)}
      onChange={e => handleChange(product, history, e)}
    />
    <p>
      Please select a Centre to check this product&apos;s availability at your
      Centre.
    </p>
  </div>
)

StockAvailability.propTypes = {
  product: PropTypes.object.isRequired,
  history: PropTypes.object,
}

export default StockAvailability
